import { API, ApiPrefixes } from "../api";

const EXIT_BASE = "cooperatives/member_exit_requests";
const MEMBER_BASE = ApiPrefixes["memberManagement"];

export const memberExitApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberExitRequests: builder.query({
      query: ({ status = "all", page = 1, limit = 20 }) => {
        const params = new URLSearchParams({
          guard: "staff",
          status: String(status),
          page: String(page),
          limit: String(limit),
        });
        return { url: `${EXIT_BASE}?${params.toString()}` };
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        { type: "member-exit-requests", id: `${arg?.status || "all"}-${arg?.page || 1}` },
        { type: "member-exit-requests", id: "LIST" },
      ],
    }),

    getStaffMemberExitRequest: builder.query({
      query: (id) => `${EXIT_BASE}/${id}?guard=staff`,
      transformResponse: (responseData) => {
        const payload = responseData?.data;
        // Normalize possible JsonResource wrapping: { data: { id, ... } }
        if (payload && typeof payload === "object" && payload.data && payload.id == null) {
          return payload.data;
        }
        return payload;
      },
      providesTags: (result, error, id) => [{ type: "member-exit-requests", id }],
    }),

    approveMemberExitRequest: builder.mutation({
      query: (requestId) => ({
        url: `${EXIT_BASE}/${requestId}/approve?guard=staff`,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "member-exit-requests" },
        { type: "Member", id: "EXITED_LIST" },
        { type: "Member", id: "LIST" },
      ],
    }),

    declineMemberExitRequest: builder.mutation({
      query: ({ requestId, decline_reason }) => ({
        url: `${EXIT_BASE}/${requestId}/decline?guard=staff`,
        method: "PUT",
        body: { decline_reason },
      }),
      invalidatesTags: [{ type: "member-exit-requests" }],
    }),

    markMemberExitPaid: builder.mutation({
      query: ({ requestId, payment_date, payment_reference }) => ({
        url: `${EXIT_BASE}/${requestId}/mark-paid?guard=staff`,
        method: "PUT",
        body: {
          payment_date,
          payment_reference: payment_reference || null,
        },
      }),
      invalidatesTags: [
        { type: "member-exit-requests" },
        { type: "Member", id: "EXITED_LIST" },
        { type: "Member", id: "LIST" },
      ],
    }),

    getExitedMembers: builder.query({
      query: ({ page = 1, limit = 20 } = {}) =>
        `${MEMBER_BASE}/exited?guard=staff&page=${page}&limit=${limit}`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "Member", id: "EXITED_LIST" }],
    }),
  }),
});

export const {
  useGetMemberExitRequestsQuery,
  useGetStaffMemberExitRequestQuery,
  useApproveMemberExitRequestMutation,
  useDeclineMemberExitRequestMutation,
  useMarkMemberExitPaidMutation,
  useGetExitedMembersQuery,
} = memberExitApi;
